import { List, ListItem, LoadingShimmer, Section } from '@icarros/ids-react';

import { EDIT_ROUTES } from '../../../utils/adEditRoutes';
import React from 'react';
import { VehicleDataWrapper } from './style';
import { formatPriceToReal } from '../../../utils/formatters';
import { pushSellerPFDashboardEvent } from '../../../../utils/pushToDataLayer';
import { useAd } from '../../../store/hooks/useAd';
import { useAdContext } from '../../../store/contexts/ad';

export function VehicleData(): JSX.Element {
  const { currentAd } = useAdContext();
  const { pushToEditForm } = useAd();

  const { corNome, portas, cambio, km, anoFabricacao, anoModelo, combustivelNome, versao } =
    currentAd?.veiculo || {};

  const { valorVenda } = currentAd || {};

  return (
    <VehicleDataWrapper>
      <Section size="section_1">dados do veículo</Section>
      <List>
        <LoadingShimmer show={!currentAd} height="60px">
          <ListItem
            label="ano do modelo"
            descript={anoModelo ? String(anoModelo) : ''}
            variant="action"
            actionOnClick={() => {
              pushSellerPFDashboardEvent('ano do modelo', 'dados do veículo');
              pushToEditForm(EDIT_ROUTES.modelYear.name);
            }}
          />
        </LoadingShimmer>
        <LoadingShimmer show={!currentAd} height="60px">
          <ListItem
            label="ano de fabricação"
            descript={anoFabricacao ? String(anoFabricacao) : ''}
            variant="action"
            actionOnClick={() => {
              pushSellerPFDashboardEvent('ano de fabricação', 'dados do veículo');
              pushToEditForm(EDIT_ROUTES.fabricationYear.name);
            }}
          />
        </LoadingShimmer>
        <LoadingShimmer show={!currentAd} height="60px">
          <ListItem
            label="versão"
            descript={versao?.nome}
            variant="action"
            actionOnClick={() => {
              pushSellerPFDashboardEvent('versão', 'dados do veículo');
              pushToEditForm(EDIT_ROUTES.version.name);
            }}
          />
        </LoadingShimmer>

        <LoadingShimmer show={!currentAd} height="60px">
          <ListItem
            label="cor"
            descript={corNome}
            variant="action"
            actionOnClick={() => {
              pushSellerPFDashboardEvent('cor', 'dados do veículo');
              pushToEditForm(EDIT_ROUTES.colors.name);
            }}
          />
        </LoadingShimmer>

        <LoadingShimmer show={!currentAd} height="60px">
          <ListItem
            label="número de portas"
            descript={String(portas)}
            variant="action"
            actionOnClick={() => {
              pushSellerPFDashboardEvent('número de portas', 'dados do veículo');
              pushToEditForm(EDIT_ROUTES.doors.name);
            }}
          />
        </LoadingShimmer>
        <LoadingShimmer show={!currentAd} height="60px">
          <ListItem
            label="câmbio"
            descript={cambio}
            variant="action"
            actionOnClick={() => {
              pushSellerPFDashboardEvent('câmbio', 'dados do veículo');
              pushToEditForm(EDIT_ROUTES.gear.name);
            }}
          />
        </LoadingShimmer>
        <LoadingShimmer show={!currentAd} height="60px">
          <ListItem
            label="combustível"
            descript={combustivelNome}
            variant="action"
            actionOnClick={() => {
              pushSellerPFDashboardEvent('combustível', 'dados do veículo');
              pushToEditForm(EDIT_ROUTES.fuel.name);
            }}
          />
        </LoadingShimmer>
        <LoadingShimmer show={!currentAd} height="60px">
          <ListItem
            label="quilometragem"
            descript={km ? `${km.toLocaleString('pt-BR')}km` : ''}
            variant="action"
            actionOnClick={() => {
              pushSellerPFDashboardEvent('quilometragem', 'dados do veículo');
              pushToEditForm(EDIT_ROUTES.km.name);
            }}
          />
        </LoadingShimmer>
        <LoadingShimmer show={!currentAd} height="60px">
          <ListItem
            label="preço"
            descript={valorVenda ? formatPriceToReal(valorVenda) : ''}
            variant="action"
            actionOnClick={() => {
              pushSellerPFDashboardEvent('preço', 'dados do veículo');
              pushToEditForm(EDIT_ROUTES.price.name);
            }}
            hasLine={false}
          />
        </LoadingShimmer>
      </List>
    </VehicleDataWrapper>
  );
}
